export default __webpack_public_path__ + "static/media/2.c19e959b.png";